<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>REQUISIÇÕES</span>
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <filtros
                    @pesquisar="pesquisar($event)"
                    :dataServicos="dataServicos"
                ></filtros>
                <app-tabela
                    :itens="requisicoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharRequisicao(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view
            :dataServicos="dataServicos"
            :rotaListagem="rotaListagem"
        ></router-view>
    </div>
</template>

<script>
import Filtros from './Filtros.vue'

export default {
    props: {
        dataServicos: {
            type: Object
        },

        rotaDetalhar: {
            type: String
        },

        rotaListagem: {
            type: String
        }
    },

    data() {
        return {
            filtro: null,
            erros: [],
            requisicoes: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'dataRequisicao',
                    label: 'Data Requisição',
                    sortable: true,
                    filterable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true
                },
                {
                    key: 'idsRm',
                    label: 'Ids RM',
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    filterable: true
                },
                {
                    key: 'solicitante',
                    label: 'Solicitante',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    type: 'status'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterRequisicoes(filtro) {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterTodas(filtro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.requisicoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar(filtro) {
            this.filtro = filtro
            this.obterRequisicoes(filtro)
        },

        detalharRequisicao(requisicao) {
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    requisicaoId: requisicao.idRequisicao
                }
            })
        }
    },

    created() {},

    computed: {
        mostrarTabela() {
            return this.$route.name === this.rotaListagem
        }
    },

    watch: {
        $route(to) {
            if (to.name === this.rotaListagem) {
                if (this.$store.getters.recarregar) {
                    if (this.filtro) {
                        this.obterRequisicoes(this.filtro)
                    }
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        Filtros
    }
}
</script>
